import React from 'react';
import { resolveListingDescriptionHtml } from '../../utils/richTextContent';

export type ListingDescriptionDisplayProps = {
  description: string | null | undefined;
  className?: string;
  emptyFallback?: string;
};

const ListingDescriptionDisplay: React.FC<ListingDescriptionDisplayProps> = ({
  description,
  className = 'policy-content text-secondary mb-0',
  emptyFallback = 'Açıklama belirtilmemiş.',
}) => {
  const html = resolveListingDescriptionHtml(description);
  if (!html) {
    return <p className="text-muted mb-0">{emptyFallback}</p>;
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default ListingDescriptionDisplay;
